import { Stack } from '@mui/material';
import React, { FC, ReactNode } from 'react';
import { ValidationError } from '@/types/validation';
import ErrorIcon from './ErrorIcon';

type ErrorNodeWrapperProps = {
  children: ReactNode;
  errors?: ValidationError[];
};

const ErrorNodeWrapper: FC<ErrorNodeWrapperProps> = ({ children, errors }) => {
  return (
    <Stack direction='row' width='100%'>
      {!!errors?.length && (
        <ErrorIcon
          tooltip={errors[0].message}
          colorize
          fontSize='small'
          severity={errors[0].severity}
          sx={{
            position: 'relative',
            zIndex: 1000,
            m: 0.25,
            alignSelf: 'center'
          }}
        />
      )}
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            ...(errors && { errors })
          });
        }
        return child;
      })}
    </Stack>
  );
};

export default ErrorNodeWrapper;
